import React from 'react';
import { BringzzText, BringzzImage } from "@bringzz/components";
import DefaultProductImage from 'assets/DefaultProductImage.png';

const ProductTab = ({ products, isAllCategory, onItemClick, toggleBookmark }) => {
    const renderProductItem = (product, index, section) => {
        if (isAllCategory) {
            return (
                <div key={`${section}-${product.id}-${index}`} className='flex items-center border-b py-2 cursor-pointer' onClick={() => onItemClick(product, 'product')}>
                    <BringzzText tag='h4'>{product.name}</BringzzText>
                    {product.formLabel ? (
                        <span className='text-gray-500 text-xs ml-2'>{product.formLabel}</span>
                    ) : null}
                </div>
            );
        }

        return (
            <div key={`${section}-${product.id}-${index}`} className='flex flex-col rounded-lg overflow-hidden cursor-pointer bg-white shadow-sm h-60' onClick={() => onItemClick(product, 'product')}>
                <div className='h-40 bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center p-4'>
                    <BringzzImage
                        src={product.image || DefaultProductImage}
                        className='max-w-full max-h-full object-contain'
                    />
                </div>
                <div className='p-2 flex-1 flex flex-col justify-start'>
                    <BringzzText tag='h5' className='text-left font-medium text-xs leading-tight line-clamp-1'>{product.name}</BringzzText>
                    {product.formLabel ? (
                        <span className='text-left text-xs text-gray-500 leading-tight mt-0.5 line-clamp-1'>{product.formLabel}</span>
                    ) : null}
                    {product.variantCount > 1 ? (
                        <span className='text-left text-xs text-magic-lilac leading-tight mt-0.5'>{product.variantCount} variants</span>
                    ) : null}
                </div>
            </div>
        );
    };

    return { renderProductItem };
};

export default ProductTab;